<template>
  <Modal id="measure-one-modal" :closeBtn="true" @close="closeModal">
    <div id="measure-one-modal-content">
      <div class="measureone-container">
        <MeasureOneWidget
          ref="m1Widget"
          :lenderId="lenderId"
          :applicant="applicant"
          :stipulationId="stip.id"
          @success="handleSuccess"
          @datasourceConnected="closeModal"
        />
      </div>
      <div class="link-container mt-11" v-if="!loading">
        <a class="text-decoration-underline" @click="$emit('confirmManualCertification')"
          >Click here to submit income documents instead</a
        >
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from "vue";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import Modal from "@/components/shared/Modal.vue";
import MeasureOneWidget from "@/components/widgets/MeasureOneWidget.vue";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
  lenderId: number;
}

const props = withDefaults(defineProps<Props>(), {});

const m1Widget = ref<InstanceType<typeof MeasureOneWidget> | null>();

const emit = defineEmits<{
  (e: "close"): void;
  (event: "success"): void;
  (e: "confirmManualCertification"): void;
}>();

const loading = computed<boolean>(() => {
  if (m1Widget.value) {
    return m1Widget.value.loading;
  }
  return false;
});

const allowCloseBtn = computed<boolean>(() => m1Widget.value?.currentProgress === 100);

const closeModal = () => {
  emit("close");
};

function handleSuccess() {
  emit("success");
  closeModal();
}

function handleClickOutside(event: any) {
  if ((event.target as HTMLElement)?.className.includes("modal-wrapper")) {
    closeModal();
  }
}

onMounted(() => {
  // Event listener for clicks on the document
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

defineExpose({
  loading,
  allowCloseBtn,
  closeModal,
});
</script>

<style scoped src="@/styles/measure-one-modal/m1-modal.css"></style>
